import "./Sidebar.scss";
import classNames from "classnames";
import { Division } from "@ir/ui";
import SidebarCollapsableHandler from "./sidebarCollapsableHandler";
import { CompactLogo, FullLogo } from "../common";
import SlideNav from "../Navigation/Navigation";
import SidebarUserMenu from "./sidebar.user";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";
import { useSidebarContext } from "@src/presentation/hooks/sidebar/useSidebarContext";

/**
 * Sidebar Component - Presentation layer
 * Single Responsibility: Provides a sidebar navigation structure
 */

const Sidebar = () => {
  const { collapsed: collapsedSidebar, setCollapsed: setCollapsedSidebar } =
    useSidebarContext();

  const sidebarHolderClass = classNames(
    "sidebar-holder",
    collapsedSidebar ? "sidebar-holder-collapsed" : "sidebar-holder-expanded",
  );

  const sidebarClassName = classNames(
    "sidebar",
    collapsedSidebar ? "collapse" : "",
    "bg-white border-right-1 border-color-grey-25",
  );

  const renderLogo = () => {
    if (collapsedSidebar) {
      return <CompactLogo />;
    }
    return <FullLogo />;
  };

  return (
    <ErrorBoundary>
      <aside className="sidebar-main">
        <Division className={sidebarHolderClass}>
          <Division className={sidebarClassName}>
            <Division className="sidebar-content">
              <Division className="sidebar-content-logo">
                {renderLogo()}
              </Division>
              <Division className="sidebar-content-logo-title">Admin</Division>
              <SlideNav />
              <Division className="sidebar-content-footer">
                <SidebarUserMenu />
              </Division>
            </Division>
          </Division>
          <SidebarCollapsableHandler
            collapsedSidebar={collapsedSidebar}
            onToggle={setCollapsedSidebar}
          />
        </Division>
      </aside>
    </ErrorBoundary>
  );
};

export default Sidebar;
